import { Button, Flex, Popover } from 'antd';
import React, { useContext } from 'react';
import { MEDIA_QUERIES } from 'src/enums';
import useWindowDimensions from 'src/hooks/useWindowDimensions';
import i18n from 'src/i18n';
import LocaleContext from 'src/LocaleContext';
import classes from 'src/screens/login/style/Login.module.css';

function Navigation() {
  const { locale } = useContext(LocaleContext);
  const [visible, setVisible] = React.useState(false);
  const { width } = useWindowDimensions();

  const languages = [
    { label: 'English', value: 'en' },
    { label: 'עברית', value: 'he' },
    { label: 'العربية', value: 'ar' },
    { label: 'русский', value: 'ru' }
  ];

  function changeLocale(lang: string) {
    if (locale !== lang) {
      i18n.changeLanguage(lang);
    }
    setVisible(false);
  }

  const content = (
    <Flex vertical style={{ zIndex: 10000 }}>
      {languages.map((lan, index) => (
        <Button
          key={index}
          onClick={() => changeLocale(lan.value)}
          className={classes.optionsButton}
        >
          {lan.label}
          <br />
        </Button>
      ))}
    </Flex>
  );

  return (
    <>
      <style>{`.ant-popover{z-index:10000 !important}`}</style>
      <Popover
        content={content}
        trigger="click"
        open={visible}
        onOpenChange={(visible) => setVisible(visible)}
      >
        <img
          src={
            (width ?? 0) < MEDIA_QUERIES.TABLET
              ? 'assets/mobileLanguage.png'
              : '/assets/language.png'
          }
        />
      </Popover>
    </>
  );
}

export default Navigation;
